import styled from 'styled-components';

const RedText = styled.span`
  color: #ff3d53;
`;

export {RedText};
